import * as tslib_1 from "tslib";
import { licensedFilterList } from '@components/shared/license/license.constants';
import { enumMapper, LicenseFrontOfficeSource, RobotType, } from '@models';
import { encodeFilters, IGridSource, ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { LicenseUrlMapFrontOffice, NamedUserLicenseService, } from '@services';
import { map } from 'rxjs/operators';
var FrontOfficeSource = /** @class */ (function () {
    function FrontOfficeSource(_namedUserLicense) {
        this._namedUserLicense = _namedUserLicense;
    }
    Object.defineProperty(FrontOfficeSource.prototype, "mapper", {
        get: function () {
            return this._namedUserLicense.mapper;
        },
        enumerable: true,
        configurable: true
    });
    FrontOfficeSource.prototype.get = function (qo) {
        return this._namedUserLicense.getLicenseDetails(this.licenseType, qo)
            .pipe(map(function (res) { return ({
            data: res.data.map(function (license) { return (tslib_1.__assign({}, license, { id: license.key })); }),
            total: res.total,
        }); }));
    };
    return FrontOfficeSource;
}());
export { FrontOfficeSource };
// FIXME: expose these from a common source
var ROBOT_TYPES = enumMapper(RobotType, {
    resourceKey: 'RobotType',
});
var ɵ0 = urlStateHandler;
var NamedLicenseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NamedLicenseComponent, _super);
    function NamedLicenseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.LicenseFrontOfficeSource = LicenseFrontOfficeSource;
        _this.licenseSourceList = enumMapper(LicenseFrontOfficeSource, {
            resourceKey: 'LicenseSource',
        }).map(function (source) { return (tslib_1.__assign({}, source, { value: Number(source.value) === LicenseFrontOfficeSource.Local })); });
        _this.licensedFilterList = licensedFilterList();
        _this.encodeFilters = encodeFilters;
        _this.getRobotType = function (type) { return ROBOT_TYPES.find(function (t) { return t.label === type; }); };
        return _this;
    }
    Object.defineProperty(NamedLicenseComponent.prototype, "isLicenseTypeAttended", {
        get: function () { return LicenseUrlMapFrontOffice.attended === this._licenseType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NamedLicenseComponent.prototype, "licenseType", {
        get: function () {
            return this._licenseType;
        },
        set: function (value) {
            this._licenseType = value;
            var svc = this._service;
            svc.licenseType = value;
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    return NamedLicenseComponent;
}(ODataGridComponent));
export { NamedLicenseComponent };
export { ɵ0 };
